const DriverOrders = ({ orders, setModal }) => {
  return (
    <div id="driver-scroll" className="order-list-col">
      {Array.isArray(orders) &&
        orders?.map((order, index) => {
          return (
            <div
              className="card p-1 border-dashed-primary"
              key={order?.orderId ?? index}
            >
              <div className="card-body">
                <div className="d-flex justify-content-between">
                  <div className="text-start">
                    <div className="d-flex">
                      <div>
                        <span className="avatar avatar-lg avatar-rounded me-1 mt-1">
                          <img
                            src={`${process.env.REACT_APP_API_PUBLIC_URL}${order?.driverPhoto}`}
                            alt="img"
                          />
                        </span>
                      </div>
                      <div className="pt-1">
                        <div className="mb-1 h6 fs-10">DRIVER</div>
                        <div className="mb-1 h6">{order?.driverName}</div>
                        <div className="mb-1 h5 fs-10">
                          <i className="ri-phone-line me-1 fw-medium align-middle"></i>
                          {order?.driverPhone}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="text-end">
                    <div className="mb-1 h4 fs-40">
                      <i
                        onClick={() => {
                          setModal({
                            open: true,
                            orderId: order?.orderId,
                            customerName: order?.orderId,
                          });
                        }}
                        className="ri-qr-code-line fw-medium align-middle cursor-pointer"
                      ></i>
                    </div>
                  </div>
                </div>
                <div className="p-3 border-top border-block-start-dashed">
                  <div className="d-flex justify-content-between">
                    <div className="text-start">
                      <div className="mb-1 h6 fs-10">CUSTOMER</div>
                    </div>
                    <div className="text-end">
                      <span className="badge bg-success-transparent ms-1">
                        {order?.orderId}
                      </span>
                    </div>
                  </div>
                  <div className="mb-1 h5 fs-10">
                    <i className="ri-phone-line me-1 fw-medium align-middle"></i>
                    {order?.customerPhone}
                  </div>
                  <div className="mb-1 h5 fs-10">
                    <i className="ri-map-pin-line me-1 fw-medium align-middle"></i>
                    {order?.area}, Block {order?.block}, {order?.street}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default DriverOrders;
